import React from 'react';
import scss from './ShiftActionButton.module.scss';
import { IconKey, Icons, IconSize } from '@pdcfrontendui/components';
import classNames from 'classnames';

export enum ShiftActionButtonVariant {
  Neutral = 'Neutral',
  Primary = 'Primary',
  Danger = 'Danger',
}

function getClassName(variant: ShiftActionButtonVariant) {
  switch (variant) {
    case ShiftActionButtonVariant.Primary:
      return scss.primary;
    case ShiftActionButtonVariant.Danger:
      return scss.danger;
    case ShiftActionButtonVariant.Neutral:
      return scss.neutral;
  }
}

export function ShiftActionButton({
  onClick,
  icon,
  children,
  variant = ShiftActionButtonVariant.Neutral,
  id,
  disabled,
  warning,
}: {
  onClick: () => void;
  icon: IconKey;
  children: string;
  variant?: ShiftActionButtonVariant;
  id?: string;
  disabled?: boolean;
  warning?: string;
}) {
  const Icon = Icons[icon];
  return (
    <button
      className={classNames(scss.comp, getClassName(variant))}
      onClick={onClick}
      aria-label={children}
      id={id}
      disabled={disabled}
    >
      <Icon size={IconSize.XSmall} className={scss.icon} />
      <div className={scss.text}>{children}</div>
      {warning && <div className={scss.warning}>{warning}</div>}
    </button>
  );
}
